module.exports = __webpack_public_path__ + "img/1563576902.922d986c.jpg";